module.exports = __webpack_public_path__ + "img/welcome_21.47e56ddf.jpg";